module.exports={account_link_complete_message:"Учётная запись Nexon привязана."};